
<div class="multiselect">
  <dropdown
    flex
    :align="align"
    :active="active"
    @close="active = false"
  >
    <div :class="['input', { active }]" @click="active = true">
      <label>{{ label }}</label>

      <div class="values">
        <div
          class="chip"
          v-for="(item, i) in value"
          :key="i"
          @click.stop="removeItem(i)"
        >
          <span>{{ item.label }}</span>

          <icon name="cancel" />
        </div>

        <input
          ref="input"
          v-model="searchString"
          @focus="onInputFocus"
          @blur="onInputBlur"
          @keydown="navigateItems"
        />
      </div>

      <icon :name="active ? 'expand_less' : 'expand_more'" class="arrow" />
    </div>

    <template #menu>
      <dropdown-menu
        :options="filteredOptions"
        :focus="itemFocus"
        @select="handleSelect"
        @mouseenter="mouseover = 'menu'"
        @mouseleave="mouseover = ''"
      />
    </template>
  </dropdown>
</div>
